<template>
  <div class="modal restore-password-modal">
    <div class="overlay" @click="$parent.closeRestore()"></div>
    <div class="wrapper">
      <img class="close" @click="$parent.closeRestore()" src="./../images/close.svg"/>
      <div class="container">
        <ValidationObserver v-if="!showSuccess" slim v-slot="{ handleSubmit, invalid, dirty, submitting }">
          <form @submit.prevent="submitRecover" class="form">
            <div class="form-wrapper">
              <div class="form-fields">
                <div class="form-fields-wrapper">
                  <div class="title">Restore password</div>
                  <ValidationProvider slim mode="eager" name="password" rules="required" v-slot="{ errors }">
                    <label>
                      <div class="desc">Password:</div>
                      <input required placeholder="Password" type="password" v-model="password"/>
                    </label>
                  </ValidationProvider>
                  <ValidationProvider slim mode="eager" name="confirmaPassword" rules="required|confirmed:password" v-slot="{ errors }">
                    <label>
                      <div class="desc">Password confirm:</div>
                      <input required placeholder="Password confirm" type="password" v-model="confirmPassword"/>
                    </label>
                  </ValidationProvider>
                  <button :disabled="(dirty && invalid) || submitting" class="button" type="submit">
                    <span>Restore</span>
                  </button>
                  <div v-if="$parent.error" class="desc red">{{ $parent.error }}</div>
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
        <div v-else class="submit-success">
          <div class="title">Password successfully changed.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate';

export default {
  name: 'RecoverModal',
  props: [],
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: function () {
    return {
      password: '',
      confirmPassword: '',
      showSuccess: '',
      error: '',
    }
  },
  mounted() {

  },
  computed: {},
  methods: {
    submitRecover() {
      let data = {
        "email": this.$route.query.email,
        "token": this.$route.query.token,
        "password": this.password,
        "password_confirmation": this.confirmPassword,
      }

      this.$http.post(process.env.VUE_APP_API + 'user/password-reset', data)
          .then((res) => {
            if (res.data.status == "OK") {
              this.showSuccess = true;
            } else {
              this.error = res.response.data.msg;
            }
          })
          .catch((error) => {
            this.error = error.response.data.msg;
          })
    }
  }
}
</script>